// Page publique de don libre (/donate/:orgId) — PublicDonatePage.jsx.
// ⚠️ Les MOTIFS de dons ("Don libre", "Kiddoush"…) sont des VALEURS envoyées
// à l'API : elles restent en français dans le payload. Seuls les libellés
// affichés (donate.motive_*) sont traduits (paire valeur/libellé côté page).
const donate = {
  fr: {
    "donate.loading": "Chargement en cours…",
    "donate.api_error_title": "Service temporairement indisponible",
    "donate.api_error_body":
      "Réessayez dans quelques instants. Si le problème persiste, contactez votre synagogue.",
    "donate.not_found_title": "Organisation introuvable",
    "donate.not_found_body": "Ce lien de don n'est plus valide.",
    "donate.back_home": "Retour à l'accueil",
    "donate.nav_tagline": "Don sécurisé · Cerfa automatique",
    "donate.amount_title": "Montant du don",
    "donate.amount_custom": "Autre montant (€)",
    "donate.tax_reduction_title": "Réduction d'impôt 66%",
    "donate.tax_reduction_body": "Vous récupérez {amount} € sur vos impôts",
    "donate.real_cost": "coût réel",
    "donate.motive_title": "Motif du don",
    "donate.motive_free": "Don libre",
    "donate.motive_kiddoush": "Kiddoush",
    "donate.motive_aliya": "Aliya Torah",
    "donate.motive_tehilim": "Tehilim",
    "donate.motive_hachnassat": "Hachnassat Kalla",
    "donate.motive_matanot": "Matanot la'evyonim",
    "donate.motive_tsedaka": "Tsedaka",
    "donate.dedication_show":
      "Dédier ce don (en l'honneur de / en mémoire de)",
    "donate.dedication_hide": "Masquer la dédicace",
    "donate.dedication_honor": "En l'honneur de",
    "donate.dedication_memory": "En mémoire de",
    "donate.dedication_placeholder": "ex : la Bar Mitsvah de Moshé Cohen",
    "donate.identity_title": "Vos coordonnées",
    "donate.anonymous": "Don anonyme",
    "donate.anonymous_note": "Votre don sera enregistré anonymement.",
    "donate.email_optional_cerfa":
      "(optionnel — pour recevoir votre reçu Cerfa)",
    "donate.email_placeholder": "votre@email.com",
    "donate.anonymous_email_hint":
      "Si renseigné, votre nom restera anonyme mais nous pourrons vous envoyer votre reçu fiscal.",
    "donate.returning_title": "Déjà donateur ?",
    "donate.returning_hint_prefix": "Saisissez votre",
    "donate.returning_hint_email": "email",
    "donate.returning_hint_or": "ou votre",
    "donate.returning_hint_phone": "téléphone",
    "donate.returning_hint_suffix":
      " : si nous vous connaissons, vous serez reconnu automatiquement.",
    // Reconnaissance SANS nom (décision du 30/09/2026) : sans code, jamais
    // le nom ni rien de la fiche ; avec le code, fiche pré-remplie.
    "donate.known_title": "On vous connaît déjà",
    "donate.known_help":
      "Aucun code à recevoir pour donner : vous passez directement au paiement sécurisé.",
    // Pas de « code par email » : par email, c'est un lien à cliquer, et le
    // SMS n'existe pas dans toutes les synagogues (relecture du 01/10/2026).
    "donate.fill_my_info": "Retrouver mes informations",
    "donate.attached_to_record":
      "Votre don sera ajouté à votre dossier : le reçu fiscal sera établi au nom qui y figure. Pour le vérifier ou le corriger, utilisez « Retrouver mes informations ».",
    "donate.name_locked":
      "Nom enregistré sur votre dossier : le reçu fiscal sera établi à ce nom. Pour un reçu à un autre nom, indiquez votre propre email.",
    "donate.address_title_optional": "Adresse pour votre reçu fiscal (facultatif)",
    "donate.verified_title": "Identité vérifiée",
    "donate.verified_body":
      "Vos informations sont pré-remplies : modifiez-les ou complétez-les, elles seront enregistrées sur votre fiche.",
    "donate.missing_name": "Il manque votre nom pour le reçu fiscal.",
    "donate.missing_address": "Il manque votre adresse pour le reçu fiscal.",
    "donate.missing_email":
      "Votre email n'est pas enregistré : il sert à vous envoyer votre reçu fiscal.",
    "donate.missing_phone":
      "Votre téléphone n'est pas enregistré : l'ajouter permet de recevoir les rappels par SMS.",
    "donate.address_title": "Adresse pour votre reçu fiscal",
    "donate.address_street": "Adresse (numéro et rue)",
    "donate.address_postal": "Code postal",
    "donate.address_city": "Ville",
    "donate.to_complete": "à compléter",
    "donate.recognized_email": "Reconnu par votre email",
    "donate.recognized_phone": "Reconnu par votre téléphone",
    "donate.already_donor": "· déjà donateur",
    "donate.start_over": "Recommencer",
    "donate.email_for_cerfa": "(pour votre reçu Cerfa)",
    "donate.phone_optional": "(optionnel)",
    "donate.err_min_amount": "Montant minimum : 1 €",
    "donate.err_company_fields":
      "Don d'entreprise : nom de l'entreprise, adresse, code postal et ville sont obligatoires.",
    "donate.err_name_required":
      "Prénom et nom obligatoires (ou cochez 'Don anonyme').",
    "donate.err_verify_first":
      "Vérifiez votre identité avant de valider votre don.",
    "donate.err_generic": "Erreur. Réessayez.",
    "donate.submit_verify_first": "Vérifiez votre identité d'abord",
    "donate.submit_donate": "Faire un don de {amount} €",
    "donate.footer_legal":
      "Paiement sécurisé via Stripe · Reçu fiscal Cerfa 11580*03 automatique · Art. 200 CGI",
  },
  en: {
    "donate.loading": "Loading…",
    "donate.api_error_title": "Service temporarily unavailable",
    "donate.api_error_body":
      "Please try again in a few moments. If the problem persists, contact your synagogue.",
    "donate.not_found_title": "Organization not found",
    "donate.not_found_body": "This donation link is no longer valid.",
    "donate.back_home": "Back to home",
    "donate.nav_tagline": "Secure donation · Automatic Cerfa (French tax receipt)",
    "donate.amount_title": "Donation amount",
    "donate.amount_custom": "Other amount (€)",
    "donate.tax_reduction_title": "66% tax deduction",
    "donate.tax_reduction_body": "You get €{amount} back on your taxes",
    "donate.real_cost": "actual cost",
    "donate.motive_title": "Donation purpose",
    "donate.motive_free": "General donation",
    "donate.motive_kiddoush": "Kiddoush",
    "donate.motive_aliya": "Torah Aliyah",
    "donate.motive_tehilim": "Tehilim",
    "donate.motive_hachnassat": "Hachnassat Kalla",
    "donate.motive_matanot": "Matanot La'evyonim",
    "donate.motive_tsedaka": "Tsedaka",
    "donate.dedication_show":
      "Dedicate this donation (in honor of / in memory of)",
    "donate.dedication_hide": "Hide dedication",
    "donate.dedication_honor": "In honor of",
    "donate.dedication_memory": "In memory of",
    "donate.dedication_placeholder": "e.g. Moshe Cohen's Bar Mitzvah",
    "donate.identity_title": "Your details",
    "donate.anonymous": "Anonymous donation",
    "donate.anonymous_note": "Your donation will be recorded anonymously.",
    "donate.email_optional_cerfa": "(optional — to receive your Cerfa receipt)",
    "donate.email_placeholder": "you@email.com",
    "donate.anonymous_email_hint":
      "If provided, your name will stay anonymous but we will be able to send you your tax receipt.",
    "donate.returning_title": "Already a donor?",
    "donate.returning_hint_prefix": "Enter your",
    "donate.returning_hint_email": "email",
    "donate.returning_hint_or": "or your",
    "donate.returning_hint_phone": "phone",
    "donate.returning_hint_suffix":
      ": if we know you, you'll be recognized automatically.",
    "donate.known_title": "We already know you",
    "donate.known_help":
      "No code needed to donate: you go straight to secure payment.",
    "donate.fill_my_info": "Retrieve my details",
    "donate.attached_to_record":
      "Your donation will be added to your record: the tax receipt will be issued in the name on file. To check or correct it, use \"Retrieve my details\".",
    "donate.name_locked":
      "Name on your record: the tax receipt will be issued in this name. For a receipt in another name, enter your own email.",
    "donate.address_title_optional": "Address for your tax receipt (optional)",
    "donate.verified_title": "Identity verified",
    "donate.verified_body":
      "Your details are pre-filled: edit or complete them, they will be saved to your record.",
    "donate.missing_name": "Your name is missing for the tax receipt.",
    "donate.missing_address": "Your address is missing for the tax receipt.",
    "donate.missing_email":
      "Your email is not on file: it is used to send you your tax receipt.",
    "donate.missing_phone":
      "Your phone number is not on file: adding it lets you receive text reminders.",
    "donate.address_title": "Address for your tax receipt",
    "donate.address_street": "Address (number and street)",
    "donate.address_postal": "Postal code",
    "donate.address_city": "City",
    "donate.to_complete": "to complete",
    "donate.recognized_email": "Recognized by your email",
    "donate.recognized_phone": "Recognized by your phone",
    "donate.already_donor": "· returning donor",
    "donate.start_over": "Start over",
    "donate.email_for_cerfa": "(for your Cerfa receipt)",
    "donate.phone_optional": "(optional)",
    "donate.err_min_amount": "Minimum amount: €1",
    "donate.err_company_fields":
      "Corporate donation: company name, address, postal code and city are required.",
    "donate.err_name_required":
      "First and last name are required (or check 'Anonymous donation').",
    "donate.err_verify_first":
      "Please verify your identity before confirming your donation.",
    "donate.err_generic": "Something went wrong. Please try again.",
    "donate.submit_verify_first": "Verify your identity first",
    "donate.submit_donate": "Donate €{amount}",
    "donate.footer_legal":
      "Secure payment via Stripe · Automatic Cerfa 11580*03 tax receipt · Art. 200 of the French Tax Code",
  },
};

export default donate;
